import { isEntitlementDeniedError } from '@lib/billing/utils/is-entitlement-denied-error';

/**
 * Returns true when a TanStack query/mutation error is an expected billing
 * entitlement denial (`402` + `ENTITLEMENT_DENIED`). These are user-facing
 * plan limits already tracked server-side via `trackEntitlementDeniedServer`
 * and surfaced in UI toasts — not actionable production faults (PORTAL-1EK).
 */
export function shouldSuppressEntitlementDeniedError(error: Error): boolean {
  return isEntitlementDeniedError(error);
}
